<cm-routed-dialog [dialogSize]="DialogSize.Small">
    <ng-container cm-overlay-content>
        <cm-details-dialog-layout [loadError]="$loadError()" [isLoaded]="!!$item()">
            <ng-container cm-title>
                <cm-title-section [title]="$title()" [isLoaded]="$item() !== undefined" (onClosed)="closeModal()"></cm-title-section>
            </ng-container>
            <ng-container cm-buttons>
                @if ($item(); as jobTask) {
                    <button class="cm-simple-window-header-button cm-item-menu" [matMenuTriggerFor]="menuOptions">
                        <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #menuOptions="matMenu">
                        <div mat-menu-item [style.cursor]="'pointer'" [matMenuTriggerFor]="copyItemsMenu">
                            <i class="far fa-copy"></i>
                            Copy
                        </div>
                        <cm-copy-value-to-clipboard-menu #copyItemsMenu [copyItems]="$copyItems()"></cm-copy-value-to-clipboard-menu>
                    </mat-menu>
                }
            </ng-container>
            <ng-container cm-main>
                <cm-section>
                    <ng-container cm-icon><i class="far fa-message"></i></ng-container>
                    <ng-container cm-title>Message</ng-container>
                    <ng-container cm-content>
                        <mat-form-field [cmIsLoading]="!$item()">
                            <textarea name="message" matInput id="message" [ngModel]="$item()?.message ?? ''" disabled></textarea>
                        </mat-form-field>
                    </ng-container>
                </cm-section>
                <cm-files-section [item]="$item()" class="cm-files"></cm-files-section>
                @if ($item()?.taskEvents; as events) {
                    <cm-section>
                        <ng-container cm-icon><i class="far fa-timeline"></i></ng-container>
                        <ng-container cm-title>History</ng-container>
                        <ng-container cm-content>
                            @if (events.length === 0) {
                                <p class="cm-history-empty">No events recorded for this task.</p>
                            } @else {
                                <ol class="cm-history">
                                    @for (event of events; track event.id) {
                                        @let view = eventView(event);
                                        <li class="cm-history-event" [attr.data-cat]="view.category">
                                            <span class="cm-history-marker"></span>
                                            <div class="cm-history-header">
                                                <span class="cm-history-label">{{ view.label }}</span>
                                                <time class="cm-history-time">{{ event.observedAt | date: "medium" }}</time>
                                            </div>
                                            @if (view.chips.length) {
                                                <div class="cm-history-chips">
                                                    @for (chip of view.chips; track $index) {
                                                        <span class="cm-history-chip" [attr.title]="chip.title ?? null"
                                                            ><i [class]="chip.icon"></i>{{ chip.text }}</span
                                                        >
                                                    }
                                                </div>
                                            }
                                            @if (view.instance) {
                                                <div class="cm-history-instance"><i class="far fa-server"></i>{{ view.instance }}</div>
                                            }
                                            @if (view.message) {
                                                <div class="cm-history-message">{{ view.message }}</div>
                                            }
                                            @for (note of view.notes; track $index) {
                                                <div class="cm-history-note">{{ note }}</div>
                                            }
                                        </li>
                                    }
                                </ol>
                            }
                        </ng-container>
                    </cm-section>
                }
            </ng-container>
            <cm-organization-select
                cm-sidebar
                [cmIsLoading]="!$item()"
                [updateOrganization]="updateItem.bind(this)"
                [organizationId]="$item()?.organization?.id ?? null"
                [disabled]="true"
            ></cm-organization-select>
            <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                <mat-label>Created by</mat-label>
                <input name="createdBy" matInput id="createdBy" [ngModel]="$item()?.createdBy?.name" disabled />
            </mat-form-field>
            <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                <mat-label>Queue group</mat-label>
                <input name="queueGroup" matInput id="queueGroup" [ngModel]="$item()?.queueGroup" disabled />
            </mat-form-field>
            <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                <mat-label>Resource group</mat-label>
                <input name="resourceGroup" matInput id="resourceGroup" [ngModel]="$currentResourceGroup() ?? '—'" disabled />
            </mat-form-field>
            @if ($item()?.job) {
                <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                    <mat-label>Resource group pin</mat-label>
                    <mat-select name="resourceGroupPin" [ngModel]="$item()?.resourceGroupPin ?? null" (ngModelChange)="setResourceGroupPin($event)">
                        <mat-option [value]="null">None (use cascade)</mat-option>
                        @for (group of $resourceGroupOptions(); track group.state) {
                            <mat-option [value]="group.state">{{ group.label }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
            <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                <mat-label>State</mat-label>
                <input name="state" matInput id="state" [ngModel]="$item()?.state" disabled />
            </mat-form-field>
            <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                <mat-label>Started</mat-label>
                <input name="started" matInput id="started" [ngModel]="$item()?.started" disabled />
            </mat-form-field>
            <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                <mat-label>Finished</mat-label>
                <input name="finished" matInput id="finished" [ngModel]="$item()?.finished" disabled />
            </mat-form-field>
            @if ($item()?.deferredUntil; as deferredUntil) {
                <mat-form-field cm-sidebar [cmIsLoading]="!$item()">
                    <mat-label>Deferred until</mat-label>
                    <input name="deferredUntil" matInput id="deferredUntil" [ngModel]="deferredUntil" disabled />
                </mat-form-field>
            }
        </cm-details-dialog-layout>
    </ng-container>
</cm-routed-dialog>
